import { action, makeObservable, observable } from 'mobx'
import { AlertData, TabsAlertData } from '@Entities/popup'
import { PublisherSideBarState } from '@App/enum/publisher-side-bar-state'

export default class PopupStore {
    private _alertData: AlertData

    private _tabsAlertData: TabsAlertData

    private _rightsholderTrayState: boolean

    private _publisherSidebarState: PublisherSideBarState

    constructor() {
        makeObservable<
            PopupStore,
            '_alertData' | '_tabsAlertData' | '_rightsholderTrayState' | '_publisherSidebarState'
        >(this, {
            _alertData: observable,
            _tabsAlertData: observable,
            _rightsholderTrayState: observable,
            _publisherSidebarState: observable,
            setAlertData: action,
            setAlertFromError: action,
            setTabsAlertData: action,
            setRightsholderTrayState: action,
            setPublisherSidebarState: action,
        })

        this._rightsholderTrayState = false
        this._publisherSidebarState = PublisherSideBarState.empty
    }

    get alertData(): AlertData | undefined {
        return this._alertData
    }

    get rightsholderTrayState(): boolean {
        return this._rightsholderTrayState
    }

    get tabsAlertData(): TabsAlertData | undefined {
        return this._tabsAlertData
    }

    get publisherSidebarState(): PublisherSideBarState {
        return this._publisherSidebarState
    }

    setAlertData(message: string, isError: boolean, dontHide = false) {
        this._alertData = { message, isError }
        if (message && !dontHide) {
            setTimeout(() => {
                this.setAlertData('', isError)
            }, 5000)
        }
    }

    setAlertFromError(error: unknown) {
        if (error instanceof Error) {
            this.setAlertData(error.message, true)
        } else {
            this.setAlertData('Something Has Gone Wrong', true)
        }
    }

    setTabsAlertData(message: string, tabName: string, isError: boolean, timeoutOff?: boolean) {
        this._tabsAlertData = { message, tabName, isError }
        if (message && !timeoutOff) {
            setTimeout(() => {
                this.setTabsAlertData('', tabName, isError)
            }, 5000)
        }
    }

    setRightsholderTrayState(state: boolean) {
        this._rightsholderTrayState = state
    }

    setPublisherSidebarState(state: PublisherSideBarState) {
        this._publisherSidebarState = state
    }
}
